// extracted by mini-css-extract-plugin
export default {"productGrid":"SY-z","centerLink":"TY-z","productSection":"UY-z","item":"VY-z","ctaButton":"WY-z"};